module.exports = __webpack_public_path__ + "img/buyGaode.0299d0d1.png";